module.exports = __webpack_public_path__ + "img/main_bg_deco_001.7d0718e.webp";